import React from 'react';
import { hexToRgbA } from '../../../../utils/hexToRGBA';
import { DateTime } from 'luxon';
import { View } from 'react-native';
import Text from '../../Text';

export type ActivityListDateDisplayOwnProps = {
    dateISO: string;
    color: string;
};

export type ActivityListDateDisplayProps = ActivityListDateDisplayOwnProps;

const SIZE = 60;

const ActivityListDateDisplay: React.FC<ActivityListDateDisplayProps> = (props) => {
    const colorWithOpacity = hexToRgbA(props.color, 0.2);
    const dateTime = DateTime.fromISO(props.dateISO);

    return (
        <View
            style={{
                width: SIZE,
                height: SIZE,
                borderRadius: 4,
                backgroundColor: colorWithOpacity,
                flexDirection: 'row',
                overflow: 'hidden',
            }}
        >
            <View
                style={{
                    width: SIZE / 8,
                    height: '100%',
                    backgroundColor: props.color,
                }}
            />
            <View
                style={{
                    flex: 1,
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Text variant="bold-caption-1" wrapText>
                    {dateTime.toFormat('ccc')}
                </Text>
                <Text variant="bold-h4">{dateTime.day}</Text>
            </View>
        </View>
    );
};

export default React.memo(ActivityListDateDisplay);
